import { render } from "./PersonalPage.vue?vue&type=template&id=5c30b590&ts=true"
import script from "./PersonalPage.vue?vue&type=script&lang=ts"
export * from "./PersonalPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__